import React, { Component } from 'react'
import YearList from '../../../YearList'
import './Timesheet.css'
import { HOST } from "../../../../config.js";
import axios from "axios";
import { toast } from 'react-toastify';


export default class Timesheet extends Component {
    constructor(props) {
        super(props)
        this.state = {
            row_ind: null,
            column_ind: null,
            beg_val: null,
            end_val: null,
            id_type_day: 0,
            type_work: null,
            type_s_day: '',
            dayTypeSelector: false,
            calendar: false,
            movement: false,
            HolydayDays: [],
            SureMove: 0,
            showpassword: 0
        }
    }

    componentDidMount() {
        this.setState({
            TimesheetPPS: this.props.TimesheetPPS,
        })
    }
    componentDidUpdate(prevState) {
        if (this.state.TimesheetPPS !== this.props.TimesheetPPS) {
            this.setState({
                TimesheetPPS: this.props.TimesheetPPS
            })
        }
    }

    OpenSelectorOptions(options, option_name) {
        this.props.OpenSelectorOptions(options, option_name)
    }

    onFocusTime = (e, row_ind, column_ind, beg_val, id_timesheet) => {
        this.setState({
            beg_val,
            row_ind,
            column_ind,
            id_timesheet
        })
    }
    onChangeTime = (e, row_ind, column_ind) => {
        this.setState({
            end_val: e.target.value,
            row_ind,
            column_ind,
        })
        let TimesheetPPS = this.props.TimesheetPPS;
        if (e.target.value <= 24) {
            TimesheetPPS[row_ind].arr[column_ind].yacheyka = Number(e.target.value)
            this.setState({ TimesheetPPS });
        }
    }

    selectDay_type = (id_type_day, type_work) => {
        this.setState({
            type_work,
            dayTypeSelector: false
        })
        if (id_type_day > 0) {
            this.props.saveUpdatedTimesheetPPS(
                this.state.id_timesheet,
                type_work !== 1 ? parseInt(this.state.beg_val) : 0,
                id_type_day)
            this.setState({ type_work: null })
        }
    }

    onBlurTime = () => {
        if (this.state.dayTypeSelector == false && !this.state.type_work && this.state.end_val !== null && this.state.end_val !== '' && this.state.beg_val !== this.state.end_val) {
            this.props.saveUpdatedTimesheetPPS(this.state.id_timesheet, this.state.end_val, 0)
        }
        setTimeout(() => {
            this.setState({
                row_ind: null,
                column_ind: null,
                beg_val: null,
                end_val: null,
            })
        }, 20);
    }

    handleKeyPress = (event) => {
        if ((event.which >= 1040 && event.which <= 1103 || event.which >= 65 && event.which <= 90 || event.which >= 97 && event.which <= 122)) {
            this.setState({ dayTypeSelector: true })
        }
        if (this.state.dayTypeSelector == false && !this.state.type_work && event.key === 'Enter') {
            if (this.state.end_val && this.state.end_val !== null && this.state.end_val !== '' && this.state.beg_val !== this.state.end_val) {
                this.props.saveUpdatedTimesheetPPS(this.state.id_timesheet, this.state.end_val, 0)
            }
            setTimeout(() => {
                this.setState({
                    row_ind: null,
                    column_ind: null,
                    beg_val: null,
                    end_val: null,
                })
            }, 20);
        }
    }

    sureDelete = (SureDel) => {
        this.props.sureDelete(SureDel)
    }

    sureMove = (SureMove) => {
        this.setState({ SureMove })
    }


    toFormTimesheet = () => {
        const {
            TimesheetPPS
        } = this.state
        this.props.toFormTimesheet(
            TimesheetPPS && TimesheetPPS.length && TimesheetPPS[0].timesheet_number,
            this.props.id_kafedra_otdel,
            this.props.id_AVN_User,
            this.props.statuss)
    }

    ViewMovement = () => {
        this.setState(prevState => ({
            movement: !prevState.movement
        }));
    }


    onSubmit = formSubmitEvent => {
        formSubmitEvent.preventDefault();
        this.postLogin(this.state.login, this.state.password)
    };

    onChangeLogin = (e) => {
        this.setState({ login: e.target.value })
    }
    onChangePassword = (e) => {
        this.setState({ password: e.target.value })
        if (e.target.value.length === 0) {
            this.showPassword(0)
        }
    }
    showPassword = (showpassword) => {
        this.setState({ showpassword })
        if (this.state.password.length === 0) {
            this.setState({ showpassword: 0 })
        }
    }

    postLogin = (login, password) => {
        axios
            .post(
                `${HOST}/api/okno/login`, { username: login, password }, { withCredentials: true }
            )
            .then((response) => response.data)
            .then((json) => {
                this.setState({ status: json.status })
                if (json.name == this.props.user_fio) {
                    this.toFormTimesheet()
                    setTimeout(() => {
                        this.sureDelete(-1)
                        this.sureMove(-1)
                    }, 100)
                }
            });
    }

    Err = () => {
        this.props.TimesheetMovement && this.props.TimesheetMovement.length &&
            this.props.TimesheetMovement.filter(a => a.approved == true && a.id_avn_login !== this.props.id_AVN_User).length && toast.warning(`Редактирование недоступно!`)

        !this.props.timesheet_visible && toast.warning(`Период составления табеля еще не наступил...`)
    }


    render() {
        const {
            Kafedra_Otdel,
            MonthList,
            DimDate,
            Type_day,
            TimesheetMovement
        } = this.props
        const {
            TimesheetPPS
        } = this.state


        function minmax(val) {
            if (val >= 0 && val <= 24) { return val }
        }
        return (
            <div>
                <div className='Timesheet'>
                    <div className='Search_container'>
                        <div className="selectors_container">
                            <div>
                                <p>Год:</p>
                                <div className="selector">
                                    <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'years') :
                                        this.OpenSelectorOptions(0, null)} >
                                        {this.props.id_a_year > 0 ? this.props.year : <b>Выберите год</b>}
                                    </h2>
                                    {this.props.options === 1 && this.props.option_name == 'years' ?
                                        <span>
                                            {YearList.map(({ id, name }, offset) => {
                                                return (
                                                    <p
                                                        style={{ color: this.props.id_a_year === id && '#7F9CF5' }}
                                                        key={offset} onClick={() => this.props.ChangeYear(id, name)}>
                                                        {name}
                                                    </p>
                                                )
                                            })}
                                        </span> : null}
                                </div>
                            </div>
                            <div>
                                <p>Месяц:</p>
                                <div className="selector">
                                    <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'month') :
                                        this.OpenSelectorOptions(0, null)} >
                                        {this.props.id_months > 0 ? this.props.months : <b>Выберите месяц</b>}
                                    </h2>
                                    {this.props.options === 1 && this.props.option_name === 'month' ?
                                        <span>
                                            {MonthList && MonthList.length && MonthList.map((item, index) => {
                                                return (
                                                    <p
                                                        style={{ color: this.props.id_months == item.id_months && '#7F9CF5' }}
                                                        key={'months' + index} onClick={() => this.props.ChangeMonth(item.id_months, item.months)}>
                                                        {item.months}
                                                    </p>
                                                )
                                            })}
                                        </span> : null}
                                </div>
                            </div>
                            <div>
                                <p>{this.props.statuss == 0 ? 'Кафедра:' : 'Отдел:'}</p>
                                <div className="selector">
                                    <h2 className="select" onClick={() => this.props.options === 0 ? this.OpenSelectorOptions(1, 'kafedra') :
                                        this.OpenSelectorOptions(0, null)} >
                                        {this.props.id_kafedra_otdel > 0 ? this.props.kafedra_otdel : <b>Выберите {this.props.statuss == 0 ? 'кафедру' : 'отдел'}</b>}
                                    </h2>
                                    {this.props.options === 1 && this.props.option_name === 'kafedra' ?
                                        <span>
                                            {Kafedra_Otdel.map((item, index) => {
                                                return (
                                                    <p
                                                        style={{ color: this.props.id_kafedra_otdel === item.id_kafedra_otdel && '#7F9CF5' }}
                                                        key={index} onClick={() => this.props.ChangeKaf_Otdel(item.id_kafedra_otdel, item.kafedra_otdel)}>
                                                        {item.kafedra_otdel}
                                                    </p>
                                                )
                                            })}
                                        </span> : null}
                                </div>
                            </div>
                        </div>
                        <div className='info_container'>
                            <div className='buttons_container'>
                                {TimesheetPPS && TimesheetPPS.length ? <button onClick={() => this.sureDelete(1)} disabled={!this.props.timesheet_visible || (TimesheetMovement && TimesheetMovement.length)}>
                                    {TimesheetMovement && TimesheetMovement.length ? 'Сформирован' : ' Сформировать'}
                                    {TimesheetMovement && TimesheetMovement.length ? <label className="TrueTrue" title="Одобрено" /> : null}
                                </button> : null}
                                {TimesheetMovement && TimesheetMovement.length ?
                                    <button onClick={this.ViewMovement}>
                                        Движение
                                    </button> : null}
                            </div>
                            <div className='info'>
                                {Type_day && Type_day.length ? Type_day.map((item, index) => {
                                    return (
                                        item.id_type_day > 0 &&
                                        <h4 className={item.type_s_day == 'В' ? 'weekend' : null}>
                                            <span style={{ color: item.colors }}>{item.type_s_day} </span> - {item.type_day.toLowerCase()}
                                        </h4>
                                    )
                                }) : null}
                            </div>
                        </div>

                    </div>
                    <div className='Timesheet_table_container'>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '30px' }}>№</th>
                                    <th style={{ minWidth: '140px' }}>Ф.И.О.</th>
                                    <th style={{ minWidth: '70px' }}>Должность</th>
                                    <th style={{ minWidth: '50px' }}>База</th>
                                    <th style={{ width: '40px' }}><div>Ставка</div></th>
                                    {DimDate && DimDate.length && DimDate.map((item, index) => {
                                        return (
                                            <th key={'DimDate' + index}
                                                className={item.Day_off == 1 && item.DayOfWeekName == 'воскресенье' ?
                                                    'Weekend DaysOf_month' : item.Day_off == 1 ?
                                                        'Weekend DaysOf_month Saturday' : 'DaysOf_month'}>
                                                {item.DayOfWeekName == 'понедельник' ? <p>Пн</p> : null}
                                                {item.DayOfWeekName == 'вторник' ? <p>Вт</p> : null}
                                                {item.DayOfWeekName == 'среда' ? <p>Ср</p> : null}
                                                {item.DayOfWeekName == 'четверг' ? <p>Чт</p> : null}
                                                {item.DayOfWeekName == 'пятница' ? <p>Пт</p> : null}
                                                {item.DayOfWeekName == 'суббота' ? <p>Сб</p> : null}
                                                {item.DayOfWeekName == 'воскресенье' ? <p>Вс</p> : null}
                                                {item.DayDate}
                                            </th>
                                        )
                                    })}
                                    <th style={{ width: '40px' }}>Всего дней</th>
                                </tr>
                            </thead>
                            <tbody onDoubleClick={this.Err}>
                                {TimesheetPPS && TimesheetPPS.length ? TimesheetPPS.map((timesheet, timesheet_ind) => {
                                    return (
                                        <tr key={'timesheet' + timesheet_ind} className={this.state.row_ind == timesheet_ind && 'Input_cliked_row'}>
                                            <td>{timesheet_ind + 1}</td>
                                            <td style={{ textAlign: 'left' }}>{timesheet.s_t_fio}</td>
                                            <td>{timesheet.post}</td>
                                            <td>{timesheet.base_over.length > 5 ? timesheet.base_over.split('')[0] + timesheet.base_over.split('')[1] + timesheet.base_over.split('')[2] + timesheet.base_over.split('')[3] + timesheet.base_over.split('')[4] + timesheet.base_over.split('')[5] + '.' : timesheet.base_over}</td>
                                            <td>{timesheet.stavka}</td>
                                            {timesheet.arr.map((item, index) => {
                                                return (
                                                    <td key={'DimDate' + index}
                                                        className={item.type_s_day == 'В' ? 'DaysOf_month Weekend' : item.type_s_day == '--' ? 'DaysOf_month work_days' : item.id_type_day > 0 && 'DaysOf_month not_work_day'}
                                                        style={{ padding: '0' }}
                                                    >
                                                        {!this.props.timesheet_visible || (TimesheetMovement && TimesheetMovement.length && TimesheetMovement.filter(a => a.approved == true && a.id_avn_login !== this.props.id_AVN_User).length) ?
                                                            <p style={{ color: item.colors, margin: '0', fontSize: '12px' }}>{item.yacheyka} </p> :
                                                            <input
                                                                type='text'
                                                                style={{ color: item.colors ? item.colors : '#3840FF' }}
                                                                className={this.state.row_ind == timesheet_ind && this.state.column_ind == index && 'Input_cliked'}
                                                                onInput={(e) => e.target.value = minmax(e.target.value)}
                                                                value={(this.state.end_val <= 24) && this.state.row_ind == timesheet_ind && this.state.column_ind == index ? this.state.end_val : item.yacheyka}

                                                                onChange={(e) => this.onChangeTime(e, timesheet_ind, index)}
                                                                onClick={(e) => this.onFocusTime(e, timesheet_ind, index, item.yacheyka, item.id_timesheet)}
                                                                onBlur={() => this.onBlurTime()}
                                                                onKeyPress={this.handleKeyPress}
                                                            />}
                                                    </td>
                                                )
                                            })}
                                            <td>
                                                {timesheet.work}
                                            </td>
                                        </tr>
                                    )
                                }) : <tr><td colSpan='37'>Период составления табеля еще не наступил...</td></tr>}
                            </tbody>
                        </table>
                        {this.state.dayTypeSelector == true ?
                            <div>
                                <div className='Teacher_list_Nav'>
                                    <div className='Teacher_list_Nav_header'>
                                        <h3>Выберите тип дня</h3>
                                        <i className="fas fa-times" style={{ top: '12px' }} onClick={() => this.selectDay_type(this.state.id_type_day, this.state.type_work)}></i>
                                    </div>
                                    {Type_day && Type_day.length ? Type_day.map((item, index) => {
                                        return (
                                            <li onClick={() => this.selectDay_type(item.id_type_day, item.type_work)} key={'type_day' + index}>
                                                <p>{item.id_type_day > 0 && item.id_type_day}</p>
                                                <p>{item.id_type_day > 0 && item.type_day}</p>
                                            </li>
                                        )
                                    }) : <li><p></p><p>нет данных</p></li>}
                                </div>
                            </div> : null}
                    </div>
                </div>

                {this.state.movement == true ?
                    <div className='Redact_okno_bg'>
                        <div className='Calendar_wrapper Movement_wrapper'>
                            <i className='fas fa-times' onClick={this.ViewMovement}></i>
                            <table>
                                <thead>
                                    <tr>
                                        <th>№</th>
                                        <th>ФИО</th>
                                        <th>Должность</th>
                                        <th>Просмотрено</th>
                                        <th>Одобрено</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {TimesheetMovement && TimesheetMovement.length ?
                                        TimesheetMovement.map((m, i) => {
                                            return (
                                                <tr>
                                                    <td>{i + 1} </td>
                                                    <td>{m.t_fio} </td>
                                                    <td>{m.timesheet_post}</td>
                                                    <td className='container'> {m.viewed > 0 ?
                                                        <label className="TrueTrue"
                                                            title="Просмотрено"
                                                        /> :
                                                        <label className="NoneNone"
                                                            title="Не проверено"
                                                        />}</td>
                                                    <td className='container'> {m.approved > 0 ?
                                                        <label className="TrueTrue"
                                                            title="Одобрено"
                                                        /> :
                                                        <label className="NoneNone"
                                                            title="Не одобрено"
                                                        />}</td>
                                                </tr>
                                            )
                                        }) : null}

                                </tbody>
                            </table>
                        </div>
                    </div>

                    : null}

                {
                    this.props.SureDel === 1 &&
                    <div className='Redact_okno_bg'>
                        <div className="Delet_Sure">
                            <p>
                                <h2>Подтвердите действие!</h2>
                                <br />
                                После нажатия на кнопку "Подтвердить", табель автоматически будет подтвержден Вами и сформирован как документ для подтверждения руководителями!
                                <br />Движение подтверждений руководителей Вы можете посмотреть нажав на кнопку
                                "Движение", который будет доступен после формирования табеля как документ.
                                <br /> После того как документ будет подтвержден одним из руководителей,
                                табель не будет доступен для редактирования!
                            </p>
                            <label
                                className="save_button"
                                onClick={() => this.sureMove(1)}
                            >
                                <i className="fas fa-check"> </i>Подтвердить
                            </label>
                            <label
                                className="cancel_button"
                                onClick={() => this.sureDelete(-1)}
                            >
                                <i className="fas fa-ban"></i>Отмена
                            </label>
                        </div>
                    </div>
                }

                {
                    this.state.SureMove === 1 &&
                    <div className='Redact_okno_bg'>
                        <form onSubmit={this.onSubmit} className='AuthoritionBlock SureMove_AuthoritionBlock'>
                            <i className='fas fa-times' onClick={() => this.sureMove(0)}></i>
                            <h3>Для подтверждения введите логин и пароль</h3>
                            <div className="pass-wrapper">
                                <input
                                    name="username"
                                    type="text"
                                    placeholder="Логин"
                                    onChange={this.onChangeLogin}
                                />
                                <i className="fas fa-user"></i>
                            </div>
                            <div className="pass-wrapper">
                                <input
                                    placeholder="Пароль"
                                    name="password"
                                    type={this.state.showpassword === 0 ? "password" : 'text'}
                                    onChange={this.onChangePassword}
                                />
                                {this.state.showpassword === 1 ? <i className="fas fa-lock-open" onClick={() => this.showPassword(0)}></i> :
                                    <i className='fa fa-lock' onClick={() => this.showPassword(1)}></i>}
                            </div>
                            <button type="submit">
                                Подтвердить
                            </button>
                            {this.state.status && this.state.status === 500 ?
                                <h4 className='err_message'>Неправильный логин или пароль!</h4> : null}
                        </form>
                    </div>
                }
            </div >
        )
    }
}
